import {Component, OnInit, Input, PLATFORM_ID, Inject} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';
import {UpdateAddressEvent} from '../../event-listeners/update-address/update-address.event';
import {AddressSelectVm} from '../../../../view-model/address-select/address-select.vm';
import {ShowSelectAddressEvent} from '../../event-listeners/show-select-address/show-select-address.event';

@Component({
  selector: 'app-address-select',
  templateUrl: './address-select.component.html',
  styleUrls: ['./address-select.component.scss'],

})
export class AddressSelectComponent implements OnInit {
  isSaG;
  address;
  showAddressPopUp = false;
  isLogin = false;
  allAddressUser = [];
  isBrowser;
  isMobile;
  showInRoute = false;
  @Input() alwaysShow = false;

  constructor(
    private vm: AddressSelectVm,
    private addressEvent: UpdateAddressEvent,
    private eventShowSelectAddress: ShowSelectAddressEvent,
    @Inject(PLATFORM_ID) platformId,
    ) {
    this.isBrowser = isPlatformBrowser(platformId) && !(navigator.userAgent.indexOf('Chrome-Lighthouse') > -1);
  }

  ngOnInit() {
    this.isMobile = this.isBrowser && window.screen.width < 991;
    this.vm.observableLogin().subscribe((res: any) => {
      this.isLogin = this.vm.isLogin();
      this.getCustomerAddress();
    });

    this.validateRoute();
  }

  toggleAddressPopUp() {
    this.showAddressPopUp = !this.showAddressPopUp;
  }

  openAddressModal() {
    this.addressEvent.changeAddressModalStatus({open: true});
  }

  getCustomerAddress() {
    this.addressEvent.updatedAddress
      .subscribe(address => {
       this.address = address;
       this.showAddressPopUp = true;
    });
  }

  validateRoute() {
    if (!this.alwaysShow) {
      this.eventShowSelectAddress.get.subscribe((res: any) => {
        this.showInRoute = res?.show;
      });
    } else {
      this.showInRoute = true;
    }
  }
}
